module.exports = __webpack_public_path__ + "static/img/banner-session-bienvenida-500x750.f700e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-session-bienvenida-500x750.jpg
// module id = MAqv
// module chunks = 47